import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-line-chart',
	templateUrl:'./LineChartPluginCompPage.html',
	styles: [],
	styleUrls:['./LineChartPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class LineChartPluginCompPage
{
	mdContent_1054 = `\`\`\`java
import com.jwebmp.plugins.chartjs.LineChart;
\`\`\``;
	mdContent_1055 = `\`\`\`java
LineChart(LineData data)
\`\`\``;
	mdContent_1056 = `\`\`\`java
LineDataset dataset = new LineDataset()
    .setLabel("Revenue")
    .setData(12, 19, 3, 5, 2, 3)
    .setFill(true)
    .setTension(0.4)
    .setBorderColor(Color.BLUE);
LineData data = new LineData()
    .addLabels("Jan", "Feb", "Mar", "Apr", "May", "Jun")
    .addDataset(dataset);
\`\`\``;
}
